import React, { useEffect, useMemo, useState } from "react";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import {cambiarEstadoUsuarioSaas, completarDowngradeSaas} from "../../firebase/saasEntitlements";
import {
  calculateSaasResourceUsage,
  formatPlanUsage,
  invitationReservesUserSeat,
  planLimitMessage,
} from "../../domain/saasEntitlementUsage";
import {
  buildUserCapacityChanges,
  canConfirmCapacitySelection,
  initialUserSeatSelection,
  invitationSeatId,
  userSeatId,
} from "../../domain/saasOverLimitSelection";
import {pendingPlanEntitlements} from "../../domain/saasPlanChange";
import {
  cancelarInvitacion,
  crearInvitacionUsuario,
  escucharInvitacionesPorCliente,
} from "../../firebase/invitacionesUsuarios";
import {
  obtenerUsuariosPorCliente,
  actualizarPermisosUsuario,
  actualizarDatosUsuario,
} from "../../firebase/usuariosConfig";

import {
  FaUserPlus,
  FaUsers,
  FaSearch,
  FaEnvelope,
} from "react-icons/fa";

function formatearFecha(fecha) {
  if (!fecha) return "-";

  const d =
    typeof fecha?.toDate === "function"
      ? fecha.toDate()
      : new Date(fecha);

  if (Number.isNaN(d.getTime())) return "-";

  return d.toLocaleString("es-AR");
}

const PERMISOS_DEFAULT_USUARIO = {
  inicio: {
    ver: true,

    verPedidos: true,
    verClientes: true,
    verIngresos: true,
    verProduccion: true,
    verAtrasados: true,
    verGrafico: true,
    verCuelloBotella: true,
  },

  clientes: {
    ver: false,
    crear: false,
    editar: false,
    eliminar: false,
  },

  pedidos: {
    ver: true,
    crear: false,
    editar: false,
    eliminar: false,
  },

produccion: {
  ver: true,
  mover: true,
  editarDetalle: true,
  asignarUsuario: false,
  verSoloAsignados: false,

  gestionarColumnas: false,
  ordenManual: false,
  cambiarColorTarjeta: false,

  verSoloSector: false,
  sectorIds: [],

  crearEtapasVinculadas: false,
  editarEtapasVinculadas: false,
  eliminarEtapasVinculadas: false,
},

  ventas: {
    ver: false,
    crear: false,
    editar: false,
    anular: false,
    listado: false,

    cotizaciones: false,
    crearCotizacion: false,
    editarCotizacion: false,
    anularCotizacion: false,
    otorgarDescuentoCotizacion: false,
    convertirCotizacion: false,
  },

caja: {
  ver: false,
  abrirCerrar: false,
  crearMovimiento: false,

  crearAporteCapital: false,
  crearRetiroCapital: false,
  crearAjustePositivo: false,
  crearAjusteNegativo: false,

  anularMovimiento: false,
  corregirApertura: false,
  historial: false,
},

  gastos: {
    ver: false,
    verDetalle: false,
    crear: false,
    editar: false,
    anular: false,
  },

  proveedores: {
    ver: false,
    crear: false,
    editar: false,
    anular: false,
  },

  listasPrecios: {
    ver: false,
    crear: false,
    editar: false,
    eliminar: false,
  },

  informes: {
    ver: false,
  },

  configuracion: {
    ver: false,
  },
};

const MODULOS_PERMISOS = [
{
  key: "inicio",
  label: "Inicio",
  acciones: [
    { key: "ver", label: "Ver módulo" },

    { key: "verPedidos", label: "Ver KPI Pedidos" },
    { key: "verClientes", label: "Ver KPI Clientes" },
    { key: "verIngresos", label: "Ver KPI Ingresos" },
    { key: "verProduccion", label: "Ver KPI Producción" },
    { key: "verAtrasados", label: "Ver KPI Atrasados" },

    { key: "verGrafico", label: "Ver gráfico semanal" },
    { key: "verCuelloBotella", label: "Ver cuello de botella" },
  ],
},
  {
    key: "clientes",
    label: "Clientes",
    acciones: [
      { key: "ver", label: "Ver" },
      { key: "crear", label: "Crear" },
      { key: "editar", label: "Editar" },
      { key: "eliminar", label: "Eliminar" },
    ],
  },
  {
    key: "pedidos",
    label: "Pedidos",
    acciones: [
      { key: "ver", label: "Ver" },
      { key: "crear", label: "Crear" },
      { key: "editar", label: "Editar" },
      { key: "eliminar", label: "Eliminar" },
    ],
  },
{
  key: "produccion",
  label: "Producción",
  acciones: [
    { key: "ver", label: "Ver módulo" },
    { key: "mover", label: "Mover tarjetas" },
    { key: "editarDetalle", label: "Editar detalle" },
    { key: "asignarUsuario", label: "Asignar usuario" },

{
  key: "verSoloAsignados",
  label: "Ver solo pedidos asignados ⚠️",
},

    {
      key: "gestionarColumnas",
      label: "Gestionar columnas",
    },

    {
      key: "ordenManual",
      label: "Configurar orden manual",
    },

    {
      key: "cambiarColorTarjeta",
      label: "Cambiar color de tarjetas",
    },
  ],
},
{
  key: "ventas",
  label: "Ventas",
  acciones: [
    { key: "ver", label: "Ver módulo" },
    { key: "crear", label: "Crear venta" },
    { key: "listado", label: "Ver listado ventas" },
    { key: "editar", label: "Editar venta" },
    { key: "anular", label: "Anular venta" },

    { key: "cotizaciones", label: "Ver cotizaciones" },
    { key: "crearCotizacion", label: "Crear cotización" },
    { key: "editarCotizacion", label: "Editar cotización" },
    { key: "anularCotizacion", label: "Anular cotización" },
    { key: "otorgarDescuentoCotizacion", label: "Otorgar descuento en cotización" },
    { key: "convertirCotizacion", label: "Convertir cotización a venta" },
  ],
},

{
  key: "caja",
  label: "Caja",
  acciones: [
    { key: "ver", label: "Ver módulo" },
    {
      key: "abrirCerrar",
      label: "Abrir / cerrar caja",
    },
    {
      key: "crearMovimiento",
      label: "Crear movimientos",
    },
    {
      key: "crearAporteCapital",
      label: "Registrar aporte de capital",
    },
    {
      key: "crearRetiroCapital",
      label: "Registrar retiro de dueño / capital",
    },
    {
      key: "crearAjustePositivo",
      label: "Crear ajuste positivo de caja",
    },
    {
      key: "crearAjusteNegativo",
      label: "Crear ajuste negativo de caja",
    },
    {
      key: "anularMovimiento",
      label: "Anular movimientos",
    },
    {
      key: "corregirApertura",
      label: "Corregir apertura",
    },
    {
      key: "historial",
      label: "Ver historial",
    },
  ],
},

{
  key: "gastos",
  label: "Gastos",
  acciones: [
    { key: "ver", label: "Ver módulo" },
    { key: "verDetalle", label: "Ver detalle" },
    { key: "crear", label: "Crear gasto" },
    { key: "editar", label: "Editar gasto" },
    { key: "anular", label: "Anular gasto" },
  ],
},

{
  key: "proveedores",
  label: "Proveedores",
  acciones: [
    { key: "ver", label: "Ver módulo" },
    { key: "crear", label: "Crear proveedor" },
    { key: "editar", label: "Editar proveedor" },
    { key: "anular", label: "Desactivar proveedor" },
  ],
},

{
  key: "listasPrecios",
  label: "Listas de precios",
  acciones: [
    { key: "ver", label: "Ver módulo" },
    { key: "crear", label: "Crear lista" },
    { key: "editar", label: "Editar lista" },
    { key: "eliminar", label: "Eliminar lista" },
  ],
},

{
  key: "informes",
  label: "Informes",
  acciones: [
    { key: "ver", label: "Ver" },
    { key: "exportar", label: "Exportar" },
  ],
},
  {
    key: "configuracion",
    label: "Configuración",
    acciones: [{ key: "ver", label: "Ver" }],
  },
];

function mensajeLimiteUsuarios(error, resourceUsage) {
  const mensaje = String(error?.message || "");

  if (!mensaje.includes("SAAS_USER_LIMIT_REACHED")) {
    return error?.message || "No se pudo completar la operación.";
  }

  const entitlements = resourceUsage?.entitlements;

  if (!entitlements || entitlements.unlimitedUsers) {
    return "No se pudo agregar el usuario.";
  }

  return `Tu plan permite hasta ${entitlements.maxUsers} usuarios. Desactivá un usuario existente o mejorá tu plan para agregar otro.`;
}

export default function ConfiguracionUsuarios({ perfil, onEntitlementsChanged }) {
  const [usuarios, setUsuarios] = useState([]);
  const [invitaciones, setInvitaciones] = useState([]);
  const [clienteSaas, setClienteSaas] = useState(null);
  const [loading, setLoading] = useState(true);

  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [rol, setRol] = useState("usuario");

  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [cancelandoId, setCancelandoId] = useState(null);
  const [seleccionCupos, setSeleccionCupos] = useState(null);
  const [aplicandoCupos, setAplicandoCupos] = useState(false);

  const [usuarioEditandoPermisos, setUsuarioEditandoPermisos] = useState(null);
  const [permisosEditando, setPermisosEditando] = useState(PERMISOS_DEFAULT_USUARIO);
  const [guardandoPermisos, setGuardandoPermisos] = useState(false);
  const [usuarioEditandoDatos, setUsuarioEditandoDatos] = useState(null);
  const [nombreEditando, setNombreEditando] = useState("");
  const [guardandoDatosUsuario, setGuardandoDatosUsuario] = useState(false);
  const [busquedaUsuario, setBusquedaUsuario] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [sectoresProduccion, setSectoresProduccion] = useState([]);
  const [
    columnasProduccionOrden,
    setColumnasProduccionOrden,
  ] = useState([]);
const [sucursalDefaultEditando, setSucursalDefaultEditando] = useState("principal");
const [sucursalesPermitidasEditando, setSucursalesPermitidasEditando] = useState(["principal"]);

  const puedeInvitar = perfil?.rol === "admin";

  async function cargarTodo() {
    try {
      if (!perfil?.clienteId) return;

      setLoading(true);

      const [usuariosData, invitacionesData, clienteSnapshot] = await Promise.all([
        obtenerUsuariosPorCliente(perfil.clienteId),
        escucharInvitacionesPorCliente(perfil.clienteId),
        getDoc(doc(db, "clientes-saas", perfil.clienteId)),
      ]);

      setUsuarios(usuariosData);
      setInvitaciones(invitacionesData);
      setClienteSaas(clienteSnapshot.exists() ? {
        id: clienteSnapshot.id, ...clienteSnapshot.data(),
      } : null);
    } catch (error) {
      console.error("Error cargando usuarios/configuración:", error);
      setMensaje("No se pudieron cargar los usuarios.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    cargarTodo();
  }, [perfil?.clienteId]);

  useEffect(() => {
    if (!perfil?.clienteId) return undefined;
    const tenant = perfil.clienteId;
    const unsubscribers = [
      onSnapshot(query(collection(db, "usuarios"), where("clienteId", "==", tenant)), (snapshot) => {
        setUsuarios(snapshot.docs.map((item) => ({uid: item.id, ...item.data()})).sort((a, b) =>
          (a.nombre || a.email || "").localeCompare(b.nombre || b.email || "")));
      }),
      onSnapshot(query(collection(db, "invitaciones_usuarios"), where("clienteId", "==", tenant)), (snapshot) => {
        setInvitaciones(snapshot.docs.map((item) => ({id: item.id, ...item.data()})).sort((a, b) =>
          Number(b.createdAt?.seconds || 0) - Number(a.createdAt?.seconds || 0)));
      }),
      onSnapshot(doc(db, "clientes-saas", tenant), (snapshot) => {
        setClienteSaas(snapshot.exists() ? {id: snapshot.id, ...snapshot.data()} : null);
      }),
    ];
    return () => unsubscribers.forEach((unsubscribe) => unsubscribe());
  }, [perfil?.clienteId]);

  useEffect(() => {
  if (!perfil?.clienteId) return;

  const q = query(
    collection(db, "sucursales"),
    where("clienteId", "==", perfil.clienteId)
  );

  const unsub = onSnapshot(q, (snap) => {
    const lista = snap.docs
      .map((d) => {
        const data = d.data();

        const esPrincipal =
          data.esPrincipal === true ||
          data.codigo === "principal" ||
          String(d.id || "").endsWith("_principal");

        return {
          firebaseId: esPrincipal ? "principal" : d.id,
          ...data,
          esPrincipal,
        };
      })
      .filter((s) => s.activa !== false)
      .sort((a, b) => {
        if (a.esPrincipal) return -1;
        if (b.esPrincipal) return 1;
        return (a.nombre || "").localeCompare(b.nombre || "");
      });

    setSucursales(lista);
  });

  return () => unsub();
}, [perfil?.clienteId]);

useEffect(() => {
  if (!perfil?.clienteId) return;

  const q = query(
    collection(db, "produccion_sectores"),
    where(
      "clienteId",
      "==",
      perfil.clienteId
    )
  );

  const unsub = onSnapshot(
    q,
    (snap) => {
      const lista = snap.docs
        .map((documento) => ({
          id: documento.id,
          ...documento.data(),
        }))
        .filter(
          (sector) =>
            sector.activo !== false
        )
        .sort((a, b) => {
          const ordenA = Number(
            a?.orden ?? 0
          );

          const ordenB = Number(
            b?.orden ?? 0
          );

          if (ordenA !== ordenB) {
            return ordenA - ordenB;
          }

          return String(
            a?.nombre || ""
          ).localeCompare(
            String(b?.nombre || "")
          );
        });

      setSectoresProduccion(lista);
    }
  );

return () => unsub();
}, [perfil?.clienteId]);

useEffect(() => {
  if (!perfil?.clienteId) return;

  const q = query(
    collection(db, "produccion_columnas"),
    where(
      "clienteId",
      "==",
      perfil.clienteId
    )
  );

  const unsub = onSnapshot(
    q,
    (snap) => {
      const lista = snap.docs
        .map((documento) => ({
          id: documento.id,
          ...documento.data(),
        }))
        .filter(
          (columna) =>
            columna.activo !== false
        )
        .sort((a, b) => {
          /*
           * Pendiente siempre primero.
           */
          if (a?.esInicial === true) {
            return b?.esInicial === true
              ? 0
              : -1;
          }

          if (b?.esInicial === true) {
            return 1;
          }

          /*
           * Producción finalizada siempre última.
           */
          if (a?.esFinal === true) {
            return b?.esFinal === true
              ? 0
              : 1;
          }

          if (b?.esFinal === true) {
            return -1;
          }

          /*
           * Las columnas intermedias siguen
           * el mismo campo orden de Producción.
           */
          const ordenA = Number(
            a?.orden ?? 0
          );

          const ordenB = Number(
            b?.orden ?? 0
          );

          if (ordenA !== ordenB) {
            return ordenA - ordenB;
          }

          return String(
            a?.id || ""
          ).localeCompare(
            String(b?.id || "")
          );
        });

      setColumnasProduccionOrden(
        lista
      );
    }
  );

  return () => unsub();
}, [perfil?.clienteId]);

const invitacionesPendientes = useMemo(
    () => invitaciones.filter((i) => invitationReservesUserSeat(i)),
    [invitaciones]
  );

const resourceUsage = useMemo(() => calculateSaasResourceUsage({
  client: clienteSaas || {}, users: usuarios, invitations: invitaciones,
  branches: sucursales,
}), [clienteSaas, usuarios, invitaciones, sucursales]);
const futureEntitlements = useMemo(() => pendingPlanEntitlements(clienteSaas || {}), [clienteSaas]);
const pendingUsersOverLimit = Boolean(futureEntitlements && !futureEntitlements.unlimitedUsers &&
  resourceUsage.usedUsers > futureEntitlements.maxUsers);
const selectionUsersOverLimit = resourceUsage.usersOverLimit || pendingUsersOverLimit;
const selectionUserLimit = futureEntitlements?.maxUsers ?? resourceUsage.entitlements.maxUsers;

useEffect(() => {
  if (!selectionUsersOverLimit) {
    setSeleccionCupos(null);
    return;
  }
  setSeleccionCupos((actual) => actual || new Set(
    initialUserSeatSelection(usuarios, invitaciones)
  ));
}, [selectionUsersOverLimit, usuarios, invitaciones]);

const alternarCupo = (id) => {
  setSeleccionCupos((actual) => {
    const siguiente = new Set(actual || []);
    if (siguiente.has(id)) siguiente.delete(id);
    else siguiente.add(id);
    return siguiente;
  });
};

async function aplicarSeleccionCupos() {
  const limit = selectionUserLimit;
  if (!seleccionCupos || !canConfirmCapacitySelection(seleccionCupos.size, limit)) return;
  const selectedNames = [
    ...usuarios.filter((usuario) => seleccionCupos.has(userSeatId(usuario.uid)))
      .map((usuario) => usuario.nombre || usuario.email || "Usuario"),
    ...invitacionesPendientes.filter((item) => seleccionCupos.has(invitationSeatId(item.id)))
      .map((item) => `${item.nombre || item.email || "Invitación"} (invitación)`),
  ];
  const confirmar = window.confirm(
    `Vas a mantener activos:\n- ${selectedNames.join("\n- ")}\n\n` +
    "Los demás usuarios quedarán inactivos y las invitaciones no elegidas se cancelarán. No se eliminarán datos ni historial."
  );
  if (!confirmar) return;
  try {
    setAplicandoCupos(true);
    setMensaje("");
    const changes = buildUserCapacityChanges({
      users: usuarios,
      invitations: invitaciones,
      selectedIds: [...seleccionCupos],
      currentUid: perfil?.uid || perfil?.firebaseUid || "",
    });
    for (const invitationId of changes.cancelInvitationIds) {
      await cancelarInvitacion(invitationId);
    }
    for (const uid of changes.deactivateUserIds) {
      await cambiarEstadoUsuarioSaas({clienteId: perfil.clienteId, uid, activo: false});
    }
    setSeleccionCupos(null);
    await cargarTodo();
    if (futureEntitlements) {
      const resultadoDowngrade =
        await completarDowngradeSaas(perfil.clienteId);

    }
    onEntitlementsChanged?.();
    setMensaje("Selección de usuarios aplicada correctamente.");
  } catch (error) {
    console.error("Error aplicando selección de usuarios:", error);
    setMensaje(error.message || "No se pudo aplicar la selección.");
    await cargarTodo();
  } finally {
    setAplicandoCupos(false);
  }
}

 const sectoresProduccionOrdenados =
  useMemo(() => {
    /*
     * Guardamos la primera posición
     * en la que aparece cada sector
     * dentro del flujo real de columnas.
     */
    const primeraPosicionPorSector =
      new Map();

    columnasProduccionOrden.forEach(
      (columna, index) => {
        const sectorId = String(
          columna?.sectorId || ""
        );

        if (!sectorId) return;

        if (
          !primeraPosicionPorSector.has(
            sectorId
          )
        ) {
          primeraPosicionPorSector.set(
            sectorId,
            index
          );
        }
      }
    );

    return [...sectoresProduccion].sort(
      (a, b) => {
        const posicionA =
          primeraPosicionPorSector.has(
            String(a.id)
          )
            ? primeraPosicionPorSector.get(
                String(a.id)
              )
            : Number.POSITIVE_INFINITY;

        const posicionB =
          primeraPosicionPorSector.has(
            String(b.id)
          )
            ? primeraPosicionPorSector.get(
                String(b.id)
              )
            : Number.POSITIVE_INFINITY;

        /*
         * Primero manda la posición real
         * de las columnas.
         */
        if (posicionA !== posicionB) {
          return posicionA - posicionB;
        }

        /*
         * Si un sector todavía no tiene
         * columnas, conservamos como fallback
         * su orden propio.
         */
        const ordenA = Number(
          a?.orden ?? 0
        );

        const ordenB = Number(
          b?.orden ?? 0
        );

        if (ordenA !== ordenB) {
          return ordenA - ordenB;
        }

        return String(
          a?.nombre || ""
        ).localeCompare(
          String(b?.nombre || "")
        );
      }
    );
  }, [
    sectoresProduccion,
    columnasProduccionOrden,
  ]); 

  async function manejarCrearInvitacion() {
    try {
      if (!puedeInvitar) return;

      setMensaje("");
      setGuardando(true);

      const resultado = await crearInvitacionUsuario({
        clienteId: perfil.clienteId,
        nombre,
        email,
        rol,
        creadoPor: {
          uid: perfil?.uid || perfil?.firebaseUid || null,
          nombre: perfil?.nombre || null,
          email: perfil?.email || null,
        },
      });

      const link = `${window.location.origin}/activar-cuenta?token=${resultado.token}`;

      try {
        await navigator.clipboard.writeText(link);
        setMensaje("Invitación creada. El link quedó copiado al portapapeles.");
      } catch {
        setMensaje("Invitación creada. Podés copiar el link desde la invitación pendiente.");
      }

      setNombre("");
      setEmail("");
      setRol("usuario");
      setMostrarFormulario(false);

      await cargarTodo();
      onEntitlementsChanged?.();
      } catch (error) {
        console.error("Error creando invitación:", error);
        setMensaje(mensajeLimiteUsuarios(error, resourceUsage));
      }
  }

  async function manejarCancelarInvitacion(invitacionId) {
    try {
      setCancelandoId(invitacionId);
      await cancelarInvitacion(invitacionId);
      await cargarTodo();
      onEntitlementsChanged?.();
    } catch (error) {
      console.error("Error cancelando invitación:", error);
      setMensaje("No se pudo cancelar la invitación.");
    } finally {
      setCancelandoId(null);
    }
  }

function abrirEditorPermisos(usuario) {
  setUsuarioEditandoPermisos(usuario);
  const permisosUsuario = usuario?.permisos || {};

  setPermisosEditando({
    ...PERMISOS_DEFAULT_USUARIO,
    ...permisosUsuario,

    caja: {
      ...PERMISOS_DEFAULT_USUARIO.caja,
      ...(permisosUsuario.caja || {}),
    },

    ventas: {
      ...PERMISOS_DEFAULT_USUARIO.ventas,
      ...(permisosUsuario.ventas || {}),
    },

    produccion: {
      ...PERMISOS_DEFAULT_USUARIO.produccion,
      ...(permisosUsuario.produccion || {}),

      sectorIds:
        Array.isArray(
          permisosUsuario
            ?.produccion
            ?.sectorIds
        )
          ? permisosUsuario
              .produccion
              .sectorIds
          : permisosUsuario
              ?.produccion
              ?.sectorId
          ? [
              permisosUsuario
                .produccion
                .sectorId,
            ]
          : [],
    },

    pedidos: {
      ...PERMISOS_DEFAULT_USUARIO.pedidos,
      ...(permisosUsuario.pedidos || {}),
    },

    gastos: {
      ...PERMISOS_DEFAULT_USUARIO.gastos,
      ...(permisosUsuario.gastos || {}),
    },
  });

  setSucursalDefaultEditando(usuario.sucursalDefaultId || "principal");
  setSucursalesPermitidasEditando(
    Array.isArray(usuario.sucursalesPermitidas) &&
      usuario.sucursalesPermitidas.length
      ? usuario.sucursalesPermitidas
      : ["principal"]
  );
}

function cerrarEditorPermisos() {
  setUsuarioEditandoPermisos(null);
  setPermisosEditando(PERMISOS_DEFAULT_USUARIO);
  setSucursalDefaultEditando("principal");
  setSucursalesPermitidasEditando(["principal"]);
}

function abrirEditorDatosUsuario(usuario) {
  setUsuarioEditandoDatos(usuario);
  setNombreEditando(usuario.nombre || "");

  const defaultId = usuario.sucursalDefaultId || "principal";
  const permitidas = Array.isArray(usuario.sucursalesPermitidas)
    ? usuario.sucursalesPermitidas
    : ["principal"];

  setSucursalDefaultEditando(defaultId);
  setSucursalesPermitidasEditando(permitidas.length ? permitidas : ["principal"]);
}

function cerrarEditorDatosUsuario() {
  setUsuarioEditandoDatos(null);
  setNombreEditando("");
  setSucursalDefaultEditando("principal");
  setSucursalesPermitidasEditando(["principal"]);
}

function toggleSucursalPermitida(sucursalId) {
  setSucursalesPermitidasEditando((prev) => {
    const actual = Array.isArray(prev) ? prev : ["principal"];
    const yaExiste = actual.includes(sucursalId);

    if (yaExiste) {
      const nuevaLista = actual.filter((id) => id !== sucursalId);

      if (nuevaLista.length === 0) {
        return actual;
      }

      if (sucursalDefaultEditando === sucursalId) {
        setSucursalDefaultEditando(nuevaLista[0]);
      }

      return nuevaLista;
    }

    const nuevaLista = [...actual, sucursalId];

    if (!sucursalDefaultEditando || !actual.includes(sucursalDefaultEditando)) {
      setSucursalDefaultEditando(sucursalId);
    }

    return nuevaLista;
  });
}

async function guardarDatosUsuario() {
  try {
    if (!usuarioEditandoDatos?.uid) return;

    setGuardandoDatosUsuario(true);
    setMensaje("");

const permitidasFinal = sucursalesPermitidasEditando.includes(
  sucursalDefaultEditando
)
  ? sucursalesPermitidasEditando
  : [...sucursalesPermitidasEditando, sucursalDefaultEditando];

await actualizarDatosUsuario(usuarioEditandoDatos.uid, {
  nombre: nombreEditando.trim(),
  sucursalDefaultId: sucursalDefaultEditando,
  sucursalesPermitidas: permitidasFinal,
});

    setMensaje("Usuario actualizado correctamente.");
    cerrarEditorDatosUsuario();
    await cargarTodo();
  } catch (error) {
    console.error("Error actualizando usuario:", error);
    setMensaje("No se pudo actualizar el usuario.");
  } finally {
    setGuardandoDatosUsuario(false);
  }
}

async function cambiarEstadoUsuario(usuario, activo) {
  try {
    if (!usuario?.uid) return;

    const texto = activo ? "reactivar" : "anular";
    const confirmar = window.confirm(`¿Querés ${texto} este usuario?`);

    if (!confirmar) return;

    setMensaje("");

    await cambiarEstadoUsuarioSaas({
      clienteId: perfil.clienteId,
      uid: usuario.uid,
      activo,
    });

    setMensaje(activo ? "Usuario reactivado." : "Usuario anulado.");
    await cargarTodo();
    onEntitlementsChanged?.();
    } catch (error) {
      console.error("Error cambiando estado de usuario:", error);

      setMensaje(
        activo
          ? mensajeLimiteUsuarios(error, resourceUsage)
          : error?.message || "No se pudo cambiar el estado del usuario."
      );
    }
}

function togglePermiso(modulo, accion) {
  const valorActual = !!permisosEditando?.[modulo]?.[accion];
  const nuevoValor = !valorActual;

  if (modulo === "produccion" && accion === "verSoloAsignados" && nuevoValor) {
    const confirmar = window.confirm(
      "Atención: si activás esta opción, el usuario solo verá los pedidos que tenga asignados.\n\nSi no tiene pedidos asignados, verá el tablero de producción vacío.\n\n¿Querés activar este permiso?"
    );

    if (!confirmar) return;
  }

if (
  modulo === "produccion" &&
  accion === "verSoloSector"
) {
  setPermisosEditando((prev) => {
    const sectoresActuales =
      Array.isArray(
        prev?.produccion?.sectorIds
      )
        ? prev.produccion.sectorIds
        : [];

    return {
      ...prev,

      produccion: {
        ...(prev.produccion || {}),

        verSoloSector:
          nuevoValor,

        sectorIds:
          nuevoValor
            ? sectoresActuales
            : [],
      },
    };
  });

  return;
}

setPermisosEditando((prev) => ({
  ...prev,
  [modulo]: {
    ...(prev[modulo] || {}),
    [accion]: nuevoValor,
  },
}));

}

  async function guardarPermisosUsuario() {
    try {
      if (!usuarioEditandoPermisos?.uid) return;

      setGuardandoPermisos(true);
      setMensaje("");

  const permitidasFinal = sucursalesPermitidasEditando.includes(
    sucursalDefaultEditando
  )
    ? sucursalesPermitidasEditando
    : [...sucursalesPermitidasEditando, sucursalDefaultEditando];

  await actualizarPermisosUsuario(
    usuarioEditandoPermisos.uid,
    permisosEditando
  );

  await actualizarDatosUsuario(usuarioEditandoPermisos.uid, {
    sucursalDefaultId: sucursalDefaultEditando,
    sucursalesPermitidas: permitidasFinal,
  });

      setMensaje("Permisos actualizados correctamente.");
      cerrarEditorPermisos();
      await cargarTodo();
    } catch (error) {
      console.error("Error guardando permisos:", error);
      setMensaje("No se pudieron actualizar los permisos.");
    } finally {
      setGuardandoPermisos(false);
    }
  }

  if (loading) {
    return <div>Cargando usuarios...</div>;
  }

  return (
    
    <div style={{ display: "grid", gap: "24px" }}>



    <div className="container-secundaria">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "12px",
              display: "grid",
              placeItems: "center",
              background: "#eef8fc",
              color: "#0796c9",
              flexShrink: 0,
            }}
          >
            <FaUsers size={18} />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <strong style={{ fontSize: "16px" }}>
              Plan
            </strong>

            <span
              style={{
                padding: "6px 12px",
                borderRadius: "999px",
                background: "#eaf7ff",
                color: "#0796c9",
                fontSize: "13px",
                fontWeight: 800,
              }}
            >
              {formatPlanUsage(
                resourceUsage.usedUsers,
                resourceUsage.entitlements.maxUsers,
                resourceUsage.entitlements.unlimitedUsers
              )}
            </span>
          </div>
        </div>

        {puedeInvitar && (
          <button
            className="btn btn-primary"
            onClick={() =>
              setMostrarFormulario((prev) => !prev)
            }
            disabled={!resourceUsage.canAddUser}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <FaUserPlus />
            {mostrarFormulario
              ? "Cerrar"
              : "Invitar usuario"}
          </button>
        )}
      </div>



      {mensaje && (
        <div
          className="alert-error"
          role="alert"
          style={{ marginTop: "14px" }}
        >
          {mensaje}
        </div>
      )}

      {puedeInvitar && mostrarFormulario && (
        <div
          style={{
            marginTop: "18px",
            padding: "18px",
            border: "1px solid #dbe7ee",
            borderRadius: "14px",
            background: "#f8fbfd",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "9px",
              marginBottom: "16px",
            }}
          >
            <FaEnvelope color="#0796c9" />
            <strong>Invitar usuario</strong>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(190px, 1fr))",
              gap: "12px",
              alignItems: "end",
            }}
          >
            <div>
              <label>Nombre</label>
              <input
                type="text"
                value={nombre}
                onChange={(e) =>
                  setNombre(e.target.value)
                }
                placeholder="Juan Pérez"
              />
            </div>

            <div>
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) =>
                  setEmail(e.target.value)
                }
                placeholder="juan@mail.com"
              />
            </div>

            <div>
              <label>Rol</label>
              <select
                value={rol}
                onChange={(e) =>
                  setRol(e.target.value)
                }
              >
                <option value="usuario">
                  Usuario
                </option>
              </select>
            </div>

            <div
              style={{
                display: "flex",
                gap: "8px",
              }}
            >
              <button
                className="btn btn-primary"
                onClick={manejarCrearInvitacion}
                disabled={
                  guardando ||
                  !resourceUsage.canAddUser
                }
              >
                {guardando
                  ? "Creando..."
                  : "Enviar invitación"}
              </button>

              <button
                className="btn"
                onClick={() => {
                  setMostrarFormulario(false);
                  setNombre("");
                  setEmail("");
                  setRol("usuario");
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

        {selectionUsersOverLimit && seleccionCupos && (
          <div className="entitlement-overlimit-panel">
            <div className="entitlement-overlimit-head">
              <div>
                <strong>Ajustá los usuarios activos</strong>
                <p>
                  {futureEntitlements ? "Tu próximo plan" : "Tu plan"} permite {selectionUserLimit} usuarios y actualmente utilizás {resourceUsage.usedUsers}.
                  Elegí cuáles conservar; no se aplicará ningún cambio hasta confirmar.
                </p>
              </div>
              <span>{seleccionCupos.size} de {selectionUserLimit} seleccionados</span>
            </div>
            <div className="entitlement-selection-grid">
              {usuarios.filter((usuario) => usuario.activo === true && usuario.rol !== "superadmin").map((usuario) => {
                const id = userSeatId(usuario.uid);
                const current = usuario.uid === (perfil?.uid || perfil?.firebaseUid);
                return (
                  <label key={id} className="entitlement-selection-item">
                    <input type="checkbox" checked={seleccionCupos.has(id)} disabled={current || aplicandoCupos} onChange={() => alternarCupo(id)} />
                    <span><strong>{usuario.nombre || usuario.email || "Usuario"}</strong><small>{current ? "Tu usuario · debe permanecer activo" : usuario.email || "Usuario activo"}</small></span>
                  </label>
                );
              })}
              {invitacionesPendientes.map((invitacion) => {
                const id = invitationSeatId(invitacion.id);
                return (
                  <label key={id} className="entitlement-selection-item">
                    <input type="checkbox" checked={seleccionCupos.has(id)} disabled={aplicandoCupos} onChange={() => alternarCupo(id)} />
                    <span><strong>{invitacion.nombre || invitacion.email || "Invitación"}</strong><small>{invitacion.email} · invitación pendiente</small></span>
                  </label>
                );
              })}
            </div>
            <div className="entitlement-overlimit-actions">
              <span>Los usuarios no seleccionados quedarán inactivos y las invitaciones pendientes se cancelarán. No se elimina historial.</span>
              <button className="btn btn-primary" disabled={aplicandoCupos || !canConfirmCapacitySelection(seleccionCupos.size, selectionUserLimit)} onClick={aplicarSeleccionCupos}>
                {aplicandoCupos ? "Aplicando..." : "Aplicar selección"}
              </button>
            </div>
          </div>
        )}

                      <div className="container-secundaria">

        <h3 style={{ marginTop: 0 }}>Invitaciones pendientes</h3>
        <div style={{ display: "grid", gap: "10px" }}>

          {invitacionesPendientes.length === 0 ? (

            <p style={{ margin: 0, color: "#666" }}>

              No hay invitaciones pendientes.

            </p>

          ) : (

            invitacionesPendientes.map((inv) => {

              const link = `${window.location.origin}/activar-cuenta?token=${inv.token}`;



              return (

                <div

                  key={inv.id}

                  style={{

                    border: "1px solid #e5e7eb",

                    borderRadius: "12px",

                    padding: "12px 14px",

                    display: "grid",

                    gap: "6px",

                    background: "#fff",

                  }}

                >

                  <strong>{inv.nombre}</strong>

                  <div>{inv.email}</div>

                  <div style={{ color: "#666", fontSize: "14px" }}>

                    Rol: {inv.rol || "usuario"}

                  </div>


                  <div style={{ color: "#666", fontSize: "13px" }}>

                    Creada: {formatearFecha(inv.createdAt)}

                  </div>

                  <div style={{ color: "#666", fontSize: "13px" }}>

                    Vence: {formatearFecha(inv.expiraAt)}

                  </div>



                  <div

                    style={{

                      marginTop: "8px",

                      padding: "8px 10px",

                      background: "#f8fafc",

                      border: "1px solid #e5e7eb",

                      borderRadius: "8px",

                      fontSize: "12px",

                      color: "#334155",

                      wordBreak: "break-all",

                    }}

                  >

                    {link}

                  </div>



                  <div

                    style={{

                      display: "flex",

                      gap: "8px",

                      flexWrap: "wrap",

                      marginTop: "8px",

                    }}

                  >

                    <button

                      className="btn"

                      onClick={async () => {

                        try {

                          await navigator.clipboard.writeText(link);

                          setMensaje("Link copiado al portapapeles.");

                        } catch {

                          setMensaje(`Copiá manualmente este link: ${link}`);

                        }

                      }}

                    >

                      Copiar link

                    </button>



                    <button

                      className="btn"

                      onClick={() => manejarCancelarInvitacion(inv.id)}

                      disabled={cancelandoId === inv.id}

                    >

                      {cancelandoId === inv.id

                        ? "Cancelando..."

                        : "Cancelar invitación"}

                    </button>

                  </div>

                </div>

              );

            })

          )}

        </div>

      </div>   

      </div>
      <div className="container-secundaria">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
         
          <div>
            <h3 style={{ margin: 10 }}>Usuarios activos</h3>

          </div>


        </div>

        <div style={{ marginBottom: "16px" }}>
          <input
            type="text"
            placeholder="Buscar usuario..."
            value={busquedaUsuario}
            onChange={(e) => setBusquedaUsuario(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
            }}
          />
        </div>

        <div style={{ marginTop: "18px", display: "grid", gap: "10px" }}>
          {usuarios.length === 0 ? (
            <p style={{ margin: 0, color: "#666" }}>
              Todavía no hay usuarios activos.
            </p>
          ) : (
            [...usuarios]
              .filter((usuario) => {
                const texto = busquedaUsuario.toLowerCase();

                return (
                  (usuario.nombre || "")
                    .toLowerCase()
                    .includes(texto) ||
                  (usuario.email || "")
                    .toLowerCase()
                    .includes(texto)
                );
              })
              .sort((a, b) => {
                if (a.activo === false && b.activo !== false) return 1;
                if (a.activo !== false && b.activo === false) return -1;
                return (a.nombre || a.email || "").localeCompare(b.nombre || b.email || "");
              })
              .map((usuario) => (
              <div
                key={usuario.uid}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "12px",
                  padding: "12px 14px",
                  display: "grid",
                  gap: "6px",
                  background: usuario.activo === false ? "#f1f5f9" : "#fff",
                  opacity: usuario.activo === false ? 0.65 : 1,
                }}
              >
                <strong>{usuario.nombre || "Sin nombre"}</strong>
                <div>{usuario.email || "-"}</div>
                <div style={{ color: "#666", fontSize: "14px" }}>
                  Rol: {usuario.rol || "usuario"}
                </div>

                <div style={{ color: "#666", fontSize: "14px" }}>
                  Sucursales:{" "}
                  {(Array.isArray(usuario.sucursalesPermitidas) &&
                  usuario.sucursalesPermitidas.length
                    ? usuario.sucursalesPermitidas
                    : ["principal"]
                  )
                    .map((id) => {
                      const sucursal = sucursales.find((s) => s.firebaseId === id);
                      const esDefault = id === (usuario.sucursalDefaultId || "principal");

                      return sucursal
                        ? `${sucursal.nombre}${esDefault ? " (por defecto)" : ""}`
                        : id;
                    })
                    .join(", ")}
                </div>

                {usuario.rol !== "admin" && usuario.rol !== "superadmin" && (
                  <div style={{ marginTop: "6px" }}>
                    <button
                      className="btn"
                      onClick={() => abrirEditorPermisos(usuario)}
                    >
                      Editar permisos
                    </button>
                    <button
                      className="btn"
                      onClick={() => abrirEditorDatosUsuario(usuario)}
                      style={{ marginLeft: "8px" }}
                    >
                      Editar nombre
                    </button>

                    <button
                      className="btn"
                      onClick={() => cambiarEstadoUsuario(usuario, usuario.activo === false)}
                      style={{ marginLeft: "8px" }}
                    >
                      {usuario.activo === false ? "Reactivar" : "Anular"}
                    </button>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>







      {usuarioEditandoPermisos && (
        <div className="produccion-modal-overlay" onClick={cerrarEditorPermisos}>
          <div
            className="produccion-modal"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "min(920px, 92vw)",
              maxHeight: "85vh",
              overflowY: "auto",
              padding: "24px",
              borderRadius: "18px",
            }}
          >
            <div style={{ marginBottom: "18px" }}>
              <h3 style={{ margin: 0 }}>
                Permisos de{" "}
                {usuarioEditandoPermisos.nombre || usuarioEditandoPermisos.email}
              </h3>
              <p style={{ margin: "6px 0 0", color: "#64748b" }}>
                Definí qué módulos puede ver y qué acciones puede realizar.
              </p>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "14px",
              }}
            >
              {MODULOS_PERMISOS.map((modulo) => (
                <div
                  key={modulo.key}
                  style={{
                    border: "1px solid #e5e7eb",
                    borderRadius: "16px",
                    padding: "16px",
                    background: "#fff",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.04)",
                  }}
                >
                  <h4 style={{ margin: "0 0 12px", fontSize: "15px" }}>
                    {modulo.label}
                  </h4>

                  <div style={{ display: "grid", gap: "10px" }}>
                    {modulo.acciones.map((accion) => (
                      <label
                        key={accion.key}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "20px minmax(0, 1fr)",
                          alignItems: "start",
                          columnGap: "10px",
                          cursor: "pointer",
                          fontSize: "14px",
                          lineHeight: "1.25",
                          width: "100%",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={!!permisosEditando?.[modulo.key]?.[accion.key]}
                          onChange={() => togglePermiso(modulo.key, accion.key)}
                          style={{
                            marginTop: "2px",
                            marginLeft: 0,
                            flexShrink: 0,
                          }}
                        />

                        <span
                          style={{
                            display: "block",
                            minWidth: 0,
                            whiteSpace: "normal",
                            wordBreak: "normal",
                            overflowWrap: "break-word",
                          }}
                        >
                          {accion.label}
                        </span>
                      </label>
                    ))}
                  </div>

                  {modulo.key === "produccion" && (
                    <div
                      style={{
                        marginTop: "16px",
                        paddingTop: "14px",
                        borderTop:
                          "1px solid #d1d5db",
                        display: "grid",
                        gap: "11px",
                      }}
                    >
                      <div>
                        <strong
                          style={{
                            fontSize: "13px",
                            color: "#475569",
                          }}
                        >
                          Acceso por sector
                        </strong>
                      </div>

                      <label
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "20px minmax(0, 1fr)",
                          alignItems: "start",
                          columnGap: "10px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            !!permisosEditando
                              ?.produccion
                              ?.verSoloSector
                          }
                          onChange={() =>
                            togglePermiso(
                              "produccion",
                              "verSoloSector"
                            )
                          }
                        />

                        <span>
                          Limitar vista por sectores
                        </span>
                      </label>

                      {permisosEditando
                        ?.produccion
                        ?.verSoloSector && (
                        <div
                          style={{
                            marginLeft: "30px",
                            display: "grid",
                            gap: "8px",
                          }}
                        >
                          <label
                            style={{
                              fontSize: "12px",
                              color: "#64748b",
                            }}
                          >
                            Sectores permitidos
                          </label>

                          <div
                            style={{
                              display: "grid",
                              gap: "6px",
                              padding: "8px",
                              border: "1px solid #e5e7eb",
                              borderRadius: "10px",
                              background: "#f8fafc",
                              maxHeight: "190px",
                              overflowY: "auto",
                            }}
                          >
                            {sectoresProduccionOrdenados.length ===
                              0 ? (
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#64748b",
                                }}
                              >
                                No hay sectores disponibles.
                              </span>
                            ) : (
                            sectoresProduccionOrdenados.map(
                              (sector) => {
                                  const sectoresSeleccionados =
                                    Array.isArray(
                                      permisosEditando
                                        ?.produccion
                                        ?.sectorIds
                                    )
                                      ? permisosEditando
                                          .produccion
                                          .sectorIds
                                      : [];

                                  const seleccionado =
                                    sectoresSeleccionados.includes(
                                      sector.id
                                    );

                                  return (
                                    <label
                                      key={sector.id}
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns:
                                          "20px minmax(0, 1fr)",
                                        alignItems: "center",
                                        gap: "8px",
                                        cursor: "pointer",
                                        padding: "5px 6px",
                                        borderRadius: "7px",
                                        background:
                                          seleccionado
                                            ? "#eef6ff"
                                            : "transparent",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={
                                          seleccionado
                                        }
                                        onChange={() => {
                                          setPermisosEditando(
                                            (prev) => {
                                              const actuales =
                                                Array.isArray(
                                                  prev
                                                    ?.produccion
                                                    ?.sectorIds
                                                )
                                                  ? prev
                                                      .produccion
                                                      .sectorIds
                                                  : [];

                                              const nuevos =
                                                actuales.includes(
                                                  sector.id
                                                )
                                                  ? actuales.filter(
                                                      (id) =>
                                                        id !==
                                                        sector.id
                                                    )
                                                  : [
                                                      ...actuales,
                                                      sector.id,
                                                    ];

                                              return {
                                                ...prev,

                                                produccion: {
                                                  ...(prev.produccion ||
                                                    {}),

                                                  sectorIds:
                                                    nuevos,
                                                },
                                              };
                                            }
                                          );
                                        }}
                                      />

                                      <span>
                                        {sector.nombre}
                                      </span>
                                    </label>
                                  );
                                }
                              )
                            )}
                          </div>
                        </div>
                      )}

                      <div
                        style={{
                          marginTop: "4px",
                          paddingTop: "14px",
                          borderTop:
                            "1px solid #e5e7eb",
                        }}
                      >
                        <strong
                          style={{
                            fontSize: "13px",
                            color: "#475569",
                          }}
                        >
                          Etapas vinculadas
                        </strong>
                      </div>

                      <label
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "20px minmax(0, 1fr)",
                          columnGap: "10px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            !!permisosEditando
                              ?.produccion
                              ?.crearEtapasVinculadas
                          }
                          onChange={() =>
                            togglePermiso(
                              "produccion",
                              "crearEtapasVinculadas"
                            )
                          }
                        />

                        <span>
                          Crear etapas vinculadas
                        </span>
                      </label>

                      <label
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "20px minmax(0, 1fr)",
                          columnGap: "10px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            !!permisosEditando
                              ?.produccion
                              ?.editarEtapasVinculadas
                          }
                          onChange={() =>
                            togglePermiso(
                              "produccion",
                              "editarEtapasVinculadas"
                            )
                          }
                        />

                        <span>
                          Editar / reabrir etapas vinculadas
                        </span>
                      </label>

                      <label
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "20px minmax(0, 1fr)",
                          columnGap: "10px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            !!permisosEditando
                              ?.produccion
                              ?.eliminarEtapasVinculadas
                          }
                          onChange={() =>
                            togglePermiso(
                              "produccion",
                              "eliminarEtapasVinculadas"
                            )
                          }
                        />

                        <span>
                          Eliminar vínculo
                        </span>
                      </label>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div
              style={{
                marginTop: 18,
                border: "1px solid #e5e7eb",
                borderRadius: 16,
                padding: 16,
                background: "#fff",
              }}
            >
              <h4 style={{ margin: "0 0 12px", fontSize: 15 }}>
                Sucursales
              </h4>



              <label style={{ marginTop: 12 }}>Sucursales permitidas</label>

              <div style={{ display: "grid", gap: 8 }}>
                {sucursales.map((s) => {
                  const esDefault = sucursalDefaultEditando === s.firebaseId;

                  return (
                    <label
                      key={s.firebaseId}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        cursor: "pointer",
                        padding: "8px 10px",
                        border: "1px solid #e5e7eb",
                        borderRadius: 10,
                        background: esDefault ? "#f0faff" : "#fff",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={sucursalesPermitidasEditando.includes(s.firebaseId)}
                        onChange={() => toggleSucursalPermitida(s.firebaseId)}
                        disabled={
                          sucursalesPermitidasEditando.length === 1 &&
                          sucursalesPermitidasEditando.includes(s.firebaseId)
                        }
                        style={{ width: "auto", margin: 0 }}
                      />

                      <span style={{ fontWeight: 600 }}>{s.nombre}</span>

                      {esDefault && (
                        <span
                          style={{
                            marginLeft: "auto",
                            padding: "3px 8px",
                            borderRadius: 999,
                            background: "#eaf7ff",
                            color: "#0096d1",
                            fontSize: 12,
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Por defecto
                        </span>
                      )}
                    </label>
                  );
                })}
              </div>
            </div>

            <div
              className="produccion-modal-actions"
              style={{ marginTop: "22px" }}
            >
              <button
                className="btn-produccion-cancelar"
                onClick={cerrarEditorPermisos}
              >
                Cancelar
              </button>

              <button
                className="btn-produccion-primario"
                onClick={guardarPermisosUsuario}
                disabled={guardandoPermisos}
              >
                {guardandoPermisos ? "Guardando..." : "Guardar permisos"}
              </button>
            </div>
          </div>
        </div>
      )}

      {usuarioEditandoDatos && (
        <div className="produccion-modal-overlay" onClick={cerrarEditorDatosUsuario}>
          <div
            className="produccion-modal"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "min(520px, 92vw)",
              padding: "24px",
              borderRadius: "18px",
            }}
          >
            <h3 style={{ marginTop: 0 }}>Editar usuario</h3>

            <label>Nombre</label>
            <input
              type="text"
              value={nombreEditando}
              onChange={(e) => setNombreEditando(e.target.value)}
              placeholder="Nombre del usuario"
            />


            <div className="produccion-modal-actions" style={{ marginTop: "22px" }}>
              <button
                className="btn-produccion-cancelar"
                onClick={cerrarEditorDatosUsuario}
              >
                Cancelar
              </button>

              <button
                className="btn-produccion-primario"
                onClick={guardarDatosUsuario}
                disabled={guardandoDatosUsuario}
              >
                {guardandoDatosUsuario ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
